import store from "../store/store";
import jwt from "./jwt";

const isSubscribed = () => {
  const token = store.getState().security.token;
  const decodedToken = jwt.decode(token);
  return decodedToken.cpl !== "Plan Freemium";
}

export default isSubscribed;